const routeByType = {
  publications: { label: 'Publication', route: 'publicationdetails' },
  events: { label: 'Event', route: 'eventdetails' },
  menus: { label: 'Page', route: 'pagedetails' },
  submenus: { label: 'Submenu', route: 'pagedetails' },
  mainmenus: { label: 'Menu', route: 'pagedetails' },
  tenders: { label: 'Tender', route: 'tenderdetails' },
  formerministers: { label: 'Former Minister', route: 'formerministerdetails' },
  directorates: { label: 'Directorate', route: 'directoratedetails' },
};

const getFields = hit => hit?.fields || hit?.attributes || hit || {};
const getText = value => {
  if (typeof value === 'string') return value;
  if (!value || typeof value !== 'object') return '';
  return value.en || value['en-US'] ||
    Object.values(value).find(item => typeof item === 'string') || '';
};

export const getSearchType = hit => {
  const rawType = hit?.sys?.contentType?.sys?.id || hit?.contentType || hit?.content_type || '';
  const type = String(rawType).toLowerCase().replace(/[^a-z]/g, '');
  if (type === 'submenu' || type === 'submenus') return 'submenus';
  if (type === 'mainmenu' || type === 'mainmenus') return 'mainmenus';
  return type;
};

export const getSearchTypeLabel = hit => routeByType[getSearchType(hit)]?.label || 'Content';

export const getSearchTitle = hit => {
  const fields = getFields(hit);
  return getText(fields.title || fields.name || fields.completename || fields.menuName ||
    fields.subMName || fields.directorateName || fields.FullName || hit?.title || hit?.name) || 'Untitled';
};

const getSlug = fields => getText(
  fields.slug || fields.Slug || fields.slugMName || fields.slugevent ||
  fields.slugtender || fields.slug_publication || fields.slug_agenda ||
  fields.slug_minister || fields.Slug_minister || fields.Slug_Event
);

const getMenuLink = fields => {
  const value = getText(fields.Link || fields.link || fields.subMLink || fields.submlink ||
    fields.href || fields.url);
  return value === '#' || value === '#/' ? '' : value.trim();
};

export const getSearchDestination = (hit, fallback = '/searchpage') => {
  const type = getSearchType(hit);
  const route = routeByType[type]?.route;
  if (!route) return fallback;

  const fields = getFields(hit);
  if (type === 'menus' || type === 'submenus' || type === 'mainmenus') {
    const menuLink = getMenuLink(fields);
    if (/^(https?:\/\/|mailto:)/i.test(menuLink)) return menuLink;
    if (menuLink.startsWith('/')) return menuLink;
    if (menuLink) return `/${menuLink}`;
  }

  const slug = getSlug(fields);
  return slug ? `/${route}/${encodeURIComponent(slug)}` : fallback;
};
